

exports.__esModule = true;

var _squid = require('squid');

var _errorHandlerHelper = require('../lib/errorHandlerHelper');

var errorHandlerHelper = _interopRequireWildcard(_errorHandlerHelper);

var _util = require('xo-wallet-components/src/fi-contingency-list/util');

var _index = require('xo-models/src/fi/index');

var _angular = require('angular');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

exports['default'] = _squid.$Component.extend('xoGuestSepaLightbox', {
    tag: 'xo-guest-sepa-lightbox',
    template: _template2['default'],

    props: {
        token: {
            type: 'var'
        },
        address: {
            type: 'var'
        },
        singlePagePaymentForm: {
            type: 'var'
        },
        errorMessage: {
            type: 'var'
        },
        validated: {
            type: 'var'
        },
        sepa: {
            type: 'var'
        },
        onboard: {
            type: 'var'
        },
        sectionElement: {
            type: 'var'
        },
        flags: {
            type: 'var'
        },
        isUnbranded: {
            type: 'var'
        },
        doneFn: {
            type: 'var'
        }
    },

    lifecycle: {
        enter: function enter() {},
        populate: function populate() {
            var _this = this;

            var openSepa = function openSepa() {
                var form = _this.singlePagePaymentForm;
                var formValid = true;
                var firstFailedElementName = determineFirstFailedElement();

                // Clear existing error messages
                _this.errorMessage = '';
                _this.validated = true;

                _this.noErrorShowSepa = false;

                function determineFirstFailedElement() {
                    var result = void 0;
                    var sepaNotRequiredFields = ['sepaAgree', 'sepaGuestAgree', 'guestagree', 'agree'];

                    for (var i in form) {
                        if (form[i] && form[i].hasOwnProperty && form[i].hasOwnProperty('$valid') && sepaNotRequiredFields.indexOf(form[i].$name) === -1 && // Dont check validity for fields we don't need for SEPA
                        !form[i].$valid) {
                            formValid = false;
                            result = form[i].$name;
                            break;
                        }
                    }

                    return result;
                }
                // If form is valid then call validateBank Api and then open sepa

                if (formValid) {
                    _this.addBankModel = new _index.$AddBankModel({
                        user: _this.onboard.user,
                        bank: _this.onboard.bank
                    });

                    _this.addBankModel.action('validate', {

                        data: _this.addBankModel.getBankData(),

                        resultModel: {},

                        success: function success(data) {
                            _this.addBankModel.creditorDetails = data.creditorDetails;
                            _this.addBankModel.fiDetails = data.fiDetails;
                            _this.noErrorShowSepa = true;
                            (0, _angular.$timeout)(function () {
                                window.scrollTo(0, 0);
                            }, 100);
                        },

                        contingencies: {
                            VALIDATE_BANK_CONTINGENCY: function VALIDATE_BANK_CONTINGENCY(name, data) {
                                _this.hideSepa();
                                _this.errorMessage = _util.$fiErrorUtil.addPageErrors(data, 'bank');
                                _util.$fiErrorUtil.addFieldErrors(data, _this.sectionElement);
                                firstFailedElementName = determineFirstFailedElement();
                                errorHandlerHelper.scrollToElement(firstFailedElementName);
                            }
                        },
                        validation: function validation(data) {

                            var returnObj = { fields: [] };
                            _this.hideSepa();

                            angular.forEach(data.fields || [], function (field) {
                                returnObj.fields.push(field.property);
                            });

                            errorHandlerHelper.addFieldError(returnObj);

                            firstFailedElementName = determineFirstFailedElement();
                            errorHandlerHelper.scrollToElement(firstFailedElementName);
                        }
                    });
                } else {
                    _this.hideSepa();
                    errorHandlerHelper.scrollToElement(firstFailedElementName);
                }
            };
            this.hideSepa = function () {
                _this.noErrorShowSepa = false;
                _this.sepa.show = false;
            };
            // Added the sepa content change based on US755520
            var setSepaOverlayContent = function setSepaOverlayContent() {
                _this.sepaTitle = _this.isUnbranded && _this.flags.show_sepa_overlay ? 'DEMemberGuest.sepaTitleUnbranded' : 'DEMemberGuest.sepaTitle';
                _this.sepaAgreement = _this.isUnbranded && _this.flags.show_sepa_overlay ? 'DEMemberGuest.ddAgreementUnbrandedPara1' : 'DEMemberGuest.ddAgreementPara1';
                if (_this.flags.show_sepa_overlay) {
                    if (_this.flags.isUnbranded && _this.flags.commit) {
                        _this.sepaSubmit = 'common.acceptAndComplete';
                    } else {
                        _this.sepaSubmit = 'common.acceptAndContinue';
                    }
                } else {
                    _this.sepaSubmit = 'header.close';
                }
            };

            this.$watch('sepa.show', function (newVal, oldVal) {
                if (newVal) {
                    openSepa();
                }
            });

            this.$watch('flags.show_sepa_overlay', function (newVal, oldVal) {
                if (newVal) {
                    setSepaOverlayContent();
                }
            });

            setSepaOverlayContent();
        }
    },
    actions: {
        closeSepa: function closeSepa($event) {
            $event.preventDefault();
            this.hideSepa();
        },
        acceptSepa: function acceptSepa($event) {
            $event.preventDefault();

            this.hideSepa();
            this.sepa.sepaGuestAgree = true;
            this.sepa.sepaAgree = true;
            if (this.flags.show_sepa_overlay) {
                this.doneFn();
            }
        }
    }
});


_squid.$Component;

_util.$fiErrorUtil;

_index.$AddBankModel;

_angular.$timeout;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./components/xo-guest-components/src/guest/sepa/directive.js
// module id = ./components/xo-guest-components/src/guest/sepa/directive.js
// module chunks = 1